import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import GeneralConfiguration from './items/GeneralConfiguration';

const PAGE_TITLE = 'passengerSettingPage_Title';

export default function PassengerSettingsPage() {
  const { t } = useTranslation();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('companySettingsPage_General')} key={'general'}>
            <GeneralConfiguration />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
